module.exports = ".maintenance__wrapper{position:absolute;top:0;left:0;right:0;bottom:0;z-index:100}\n"